import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { getAuth, createUserWithEmailAndPassword, sendEmailVerification, updateProfile } from "firebase/auth";
import app from './firebase.init';
import isValidEmail from "../../utils/isValidEmail";
// import isValidPassword from "../../utils/isValidPassword";
import { toast } from 'react-toastify';
import LoginWithGoogle from './LoginWithGoogle';
import LoginWithFacebook from './LoginWithFacebook';
import { setUserInfo } from '../../features/user/userSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useCreateTokenMutation } from '../../features/api/apiSlice';


const Register = () => {
    const { i18n } = useSelector(state => state.someFun);
    const [translate, setTranslate] = useState(true);

    useEffect(() => {
        if (i18n === 'en') {
            setTranslate(true)
        }
        else {
            setTranslate(false)
        }
    }, [i18n]);


    const [createToken, { data: token, isError, isSuccess }] = useCreateTokenMutation();
    const dispatch = useDispatch();

    const { register, handleSubmit, formState: { errors } } = useForm();
    const [massage, setMassage] = useState({
        massage: "",
        status: "",
        view: false
    });


    let navigate = useNavigate();
    let location = useLocation();

    let { from } = location.state || { from: { pathname: "/" } };

    const auth = getAuth(app);
    const onSubmit = formData => {
        const email = formData.email;
        const password = formData.password;
        if (!isValidEmail(email)) {
            return toast.error("Email is not valid", {
                position: "bottom-left",
            });
        }
        else if (password.length < 6) {
            return toast.error("weak-password: Password should be at least 6 characters ", {
                position: "bottom-left",
            });
        }
        else {
            createUserWithEmailAndPassword(auth, email, password)
                .then((userCredential) => {
                    const user = userCredential.user;
                    if (user) {
                        toast.success("Your Registation Successfully", {
                            position: "bottom-left",
                        });
                        verifyEmail();
                        updateUserInfo(formData);
                        dispatch(setUserInfo(user));
                        createToken({ email: email, uid: user.uid });
                    }
                })
                .catch((error) => {
                    // const errorCode = error.code;
                    const errorMessage = error.message;
                    toast.error(`${errorMessage}`, {
                        position: "bottom-left",
                    });
                });
        }
    };

    const updateUserInfo = (formData) => {
        updateProfile(auth.currentUser, {
            displayName: formData.name,
            // photoURL: "https://example.com/jane-q-user/profile.jpg"
        }).then(() => {
            // Profile updated!
            // ...
        }).catch((error) => {
            // An error occurred
            toast.error("There was a problem adding your name You can add a name later.", {
                position: "bottom-left",
            });
        });

    };

    const verifyEmail = () => {
        sendEmailVerification(auth.currentUser)
            .then(() => {
                setMassage({
                    massage: "Please verify your email. Please check your email inbox. Or please check the spam box",
                    status: "success",
                    view: true
                })
                toast.success("send verify email", {
                    position: "bottom-left",
                });
            });
    };

    useEffect(() => {
        if (isSuccess) {
            navigate(from);
        }
        else if (isError) {
            toast.error("Something is wrong !! Try again", {
                position: "bottom-left",
            });
        }
    }, [isSuccess, navigate]);


    return (
        <div>
            <div className="flex justify-center">
                <div className="grid grid-cols-3 lg:w-4/6 w-full h-full p-3">
                    <div className="col-span-2">
                        <h2 className="text-xl font-medium text-gray-700 font-poppins">
                            {translate ? "Create your Deer Perfume Account" : "আপনার Deer Perfume অ্যাকাউন্ট তৈরি করুন"}
                        </h2>
                    </div>
                    <div className="col-span-1 text-end">
                        <p className='text-sm text-gray-500'>
                            {translate ?
                                <> Already member? <Link to="/auth"><span className='text-blue-700 cursor-pointer'>Login</span></Link> here.                                </>
                                :
                                <> ইতিমধ্যে সদস্য? <Link to="/auth"><span className='text-blue-700 cursor-pointer'>এখানে লগইন</span></Link> করুন.                                </>
                            }
                        </p>
                    </div>
                </div>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className=' flex justify-center mb-1 text-center'>
                    {massage?.view &&
                        <div className="p-3 md:w-4/6 bg-white font-semibold">
                            <p className={massage.status === 'success' ?
                                `text-green-600` : `text-red-700`}>{massage.massage}</p>
                        </div>
                    }
                </div>
                <div className="flex justify-center">

                    <div className="grid grid-cols-2 md:gap-12 shadow lg:w-4/6 w-full h-full bg-white p-4 pb-5">

                        <div className="md:col-span-1 col-span-2">
                            <div className="mb-4">
                                <label className="block text-sm font-normal text-gray-600 mb-0">
                                    {translate ? "Full Name*" : "পুরো নাম*" }
                                </label>
                                <input
                                    type="text"
                                    placeholder={translate ? "Enter your first and last name" : "আপনার প্রথম এবং শেষ নাম লিখুন" }
                                    name="name"
                                    {...register("name", { required: true })}
                                    className="h-9 focus:outline-offset-2  outline-blue-500/50 text-gray-600 my-1 border border-gray-400 w-full py-3 px-2 focus:outline-none font-poppins"

                                />
                                {errors.name && <span className='text-red-600'>{translate ? "This field is required" : "ঘরটি অবশ্যই পূরণ করতে হবে" }</span>}
                            </div>

                            <div className='mb-4 '>
                                <label className="block text-sm font-normal text-gray-600 mb-0">
                                    {translate ? "Email Address*" : "ইমেইল ঠিকানা*" }
                                </label>
                                <input
                                    type="email"
                                    placeholder={translate ? "Please enter your Email" : "আপনার ইমেল ঠিকানা লিখুন দয়া করে" }
                                    name="email"
                                    {...register("email", { required: true })}
                                    className="h-9 focus:outline-offset-2  outline-blue-500/50 text-gray-600 my-1 border border-gray-400 w-full py-3 px-2 focus:outline-none font-poppins"

                                />
                                {errors.email && <span className='text-red-600'>{translate ? "This field is required" : "ঘরটি অবশ্যই পূরণ করতে হবে" }</span>}
                            </div>
                            <div className="">
                                <label className="block text-sm font-normal text-gray-600 mb-0">
                                    
                                    {translate ? "Password*" : "পাসওয়ার্ড*" }
                                </label>
                                <input
                                    // type="password"
                                    placeholder={translate ? "Minimum 6 Characters with a number and a letter" : "সংখ্যা এবং অক্ষর সহ ন্যূনতম 6 অক্ষর" }
                                    name="email"
                                    {...register("password", { required: true })}
                                    className="h-9 focus:outline-offset-2  outline-blue-500/50 text-gray-600 my-1 border border-gray-400 w-full py-3 px-2 focus:outline-none font-poppins"

                                />
                                {errors.password && <span className='text-red-600'>{translate ? "This field is required" : "ঘরটি অবশ্যই পূরণ করতে হবে" }</span>}
                            </div>
                            <p className='text-sm text-end text-blue-600 py-2.5'><Link to="/auth/forget-password">{translate ? "Forgot Password?" : "পাসওয়ার্ড ভুলে গেছেন?" }</Link></p>

                        </div>
                        <div className="md:col-span-1 col-span-2">
                            <div className="h-full grid content-center">
                                <div>
                                    <button type="submit" className="w-full py-[13px] my-1.5 rounded text-white bg-bnd-1 font-poppins">{translate ? "SIGN UP" : "নিবন্ধন করুন" } </button>
                                    <p className="text-sm text-gray-500 pt-0.5 pb-2">{translate ? "By clicking “SIGN UP”, I agree to Deer Perfume's" : "'নিবন্ধন করুন' ক্লিক করে, আমি Deer Perfum এর" }  <Link to="/terms-and-conditions" className='text-blue-600'>{translate ? "Terms of Use" : "ব্যবহারের শর্তাবলী" }</Link> {translate ? "and Privacy Policy" : "এবং গোপনীয়তা নীতিতে সম্মত" }</p>
                                    <p className="text-sm text-gray-500 py-1">{translate ? "Or, login with" : "অথবা, এগুলো দিয়ে লগইন করুন" } </p>
                                    <LoginWithFacebook />
                                    <LoginWithGoogle />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </div>
    );
};

export default Register;